import { ref, get, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetInvoiceDataFirebase from "./GetInvoiceDataFirebase";

const DeleteInvoiceDataInFirebase = async (state, dispatch, uniqueID, userId) => {
    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);
    console.log("uniqueID", uniqueID);


    if (!USERID) return null;

    try {
        // Reference to the specific invoice in Firebase
        const userRef = ref(
            database,
            `invoiceGenerator/users/${USERID}/billInvoice/${uniqueID}`
        );

        // First check if invoice exists
        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Invoice not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });

        // Fetch updated invoice data
        await GetInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "Invoice marked as deleted!" };
    } catch (error) {
        return {
            success: false,
            message: error.message || "Failed to mark invoice as deleted.",
        };
    }
};

export default DeleteInvoiceDataInFirebase;
